export default __webpack_public_path__ + "static/media/foto3.81e29260.jpg";